import tmhRequest from '@/config/tmhRequest'

export default {
    searchAddress: function (data) {
        return tmhRequest({
            url: '/common/tmh/map/searchaddress',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/common/map.js